





















































































































































































































































































































































































































import Vue, { VNode } from "vue";
import store, { GeneralIngoingInvoiceStore } from "../services/GeneralIngoingInvoiceStore";
import Page from "../../../components/Page.vue";
import configuration, { AppConfiguration } from "@/models/Configuration";
import GeneralIngoinInvoiceDisplay from "../models/GeneralIngoinInvoiceDisplay";
import GeneralIngoingInvoiceDetails from "./GeneralIngoingInvoiceDetails.vue";
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import links from "../../../models/Links";
import IncomingInvoicePageFilter from "./IncomingInvoicePageFilter.vue";
import { GridColumnProps, GridRowProps } from "@progress/kendo-vue-grid";
import CustomsInvoiceDetails from "@/modules/customsInvoice/views/CustomsInvoiceDetails.vue";
import debounce from "debounce";
import eventBus from "../../../services/eventBus";
import InvoiceStockModifierGenisView from "../../incomingInvoice/invoiceStockModification/views/InvoiceStockModfierGenisView.vue";
import { FilteringModel, SortingModel, SortOrder } from "@/services/filtering";
import dayjs from "dayjs";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import AccStatus, { accStatusDefaultProps } from "../models/AccStatus";
import { accountStatusDefaultProps } from "@/modules/notice/models/AccountStatus";
import DisplayStatus, { displayStatusDefaultProps } from "../models/DisplayStatus";
import WorkflowStatus, { workflowStatusDefaultProps } from "../models/WorkflowStatus";
import { getUserSettingValue, setUserSetting } from "@/services/userSettings";
import {
  InvoiceViewMode,
  normalizeViewMode,
  viewModeControlName,
  viewModeSettingType,
} from "../services/invoiceViewMode";
import GridLayoutMenu from "@/components/GridLayoutMenu.vue";
import { GridLayoutSettings } from "@/services/GridLayoutSettings";
import globalStore from "@/models/GlobalStore";
import NavigationButton from "@/components/NavigationButton.vue";

/** A profilba mentett szűrő: a Kendo szűrősor leírója + a fejléc-legördülők (státuszok) kiválasztott azonosítói. */
interface SavedGridFilter {
  grid?: CompositeFilterDescriptor;
  dropdowns?: Record<string, number>;
}

/** Egy ID = Összes: nincs szűrés a legördülőn. */
const allStatusId = 1;

function savedGridFilter(value: unknown): SavedGridFilter {
  if (!value || typeof value !== "object") return {};
  // Korábbi profilok a Kendo szűrő-leírót közvetlenül tartalmazzák (logic + filters), legördülők nélkül.
  if ("logic" in (value as Record<string, unknown>)) return { grid: value as CompositeFilterDescriptor };
  return value as SavedGridFilter;
}

interface Data {
  configuration: AppConfiguration;
  store: GeneralIngoingInvoiceStore;
  filterShow: boolean;
  currentPageNumber: number;
  currentPageSize: number;
  firstPageNumberButtonVisible: boolean;
  firstPageNumberButtonValue: number;
  secondPageNumberButtonVisible: boolean;
  secondPageNumberButtonValue: number;
  thirdPageNumberButtonVisible: boolean;
  thirdPageNumberButtonValue: number;
  fourthPageNumberButtonVisible: boolean;
  fourthPageNumberButtonValue: number;
  fifthPageNumberButtonVisible: boolean;
  fifthPageNumberButtonValue: number;
  isTableView: boolean;
  isListView: boolean;
  savedViewMode: InvoiceViewMode;
  layout: GridLayoutSettings;
  filterText: string;
  lastSentFilterText: string;
  invDateStart: string;
  invDateEnd: string;
  accDateStart: string;
  accDateEnd: string;
  insDateStart: string;
  insDateEnd: string;
  invStatus: string;
  invPartner: string;
  filter: CompositeFilterDescriptor;
  sort: SortDescriptor[];
  debounceTimer: any;
  jsonFilters: JSONScheme;
  defaultDisplayStatus: DisplayStatus;
  defaultWorkflowStatus: WorkflowStatus;
  defaultAccStatus: AccStatus;
  /** A fejléc-legördülők kiválasztott státusz-azonosítói mezőnként (displayStatus, workflowStatus, accStatus); 1 = Összes. */
  dropdownFilterIds: Record<string, number>;
  jsonSort: any;
  incomingInvoiceFilter: string;
}

interface Methods {
  createInvoice(): void;
  updateInvoice(item: GeneralIngoinInvoiceDisplay): void;
  invoiceEditUrl(item: GeneralIngoinInvoiceDisplay): string;
  setPageNumbers(): void;
  setCurrentPageNumber(pageNumber: number): void;
  decrementPageNumber(): void;
  incrementPageNumber(): void;
  setTableView(): void;
  setListView(): void;
  applyViewMode(mode: InvoiceViewMode): void;
  loadViewMode(): Promise<void>;
  saveViewMode(mode: InvoiceViewMode): Promise<void>;
  openLayoutMenu(event: MouseEvent): void;
  partnerEdit(item: GeneralIngoinInvoiceDisplay): void;
  filterTextChanged(): void;
  reloadByAccDate(): void;
  reloadByInvDate(): void;
  reload(silent?: boolean): void;
  filterChange(e: { filter: CompositeFilterDescriptor }): void;
  dropdownFilterChange(e: { filter: CompositeFilterDescriptor }): void;
  sortChange(e: { sort: SortDescriptor[] }): void;
  filterTransform(filter: any): void;
  dropdownFilterTransform(field: string, value: number | null): void;
  applyDropdownFilters(): void;
  syncDropdownItems(): void;
  convertToDate(dateString: string): string;
  sortTransform(): void;
}

interface Computed {
  columns: GridColumnProps[];
  baseColumns: GridColumnProps[];
  items: GeneralIngoinInvoiceDisplay[];
  footerText: string;
  maxPageNumber: number;
  invoices: GeneralIngoinInvoiceDisplay[];
  invoiceCount: number;
  accountStatuses: AccStatus[];
  workflowStatuses: WorkflowStatus[];
  displayStatuses: DisplayStatus[];
  pageTitle: string;
  newInvoiceButtonText: string;
}

interface Field {
  operator: string;
  value: null | string;
  operators: string[];
}

interface JSONScheme {
  [fieldName: string]: Field;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    Page,
    GeneralIngoingInvoiceDetails,
    CustomsInvoiceDetails,
    IncomingInvoicePageFilter,
    InvoiceStockModifierGenisView,
    NavigationButton,
    GridLayoutMenu,
    "k-dropdown-list": DropDownList
  },

  data(): Data {
    // A data() futásakor a computed/methods típusa még nem látszik a this-en; a callbackek később futnak.
    const page = this as unknown as Vue & Data & Methods & Computed;
    return {
      configuration,
      store,
      filterShow: false,
      currentPageNumber: 1,
      currentPageSize: 10,
      firstPageNumberButtonVisible: true,
      firstPageNumberButtonValue: 1,
      secondPageNumberButtonVisible: true,
      secondPageNumberButtonValue: 2,
      thirdPageNumberButtonVisible: true,
      thirdPageNumberButtonValue: 3,
      fourthPageNumberButtonVisible: true,
      fourthPageNumberButtonValue: 4,
      fifthPageNumberButtonVisible: true,
      fifthPageNumberButtonValue: 5,
      isTableView: false,
      isListView: true,
      savedViewMode: "list",
      // Grid elrendezés-profilok (rmgenuser_setting, control_name = GENERAL_INCOMING_INVOICES).
      // A rendezés és a szűrősor szerver oldali, ezért profil betöltése után újratöltünk.
      layout: new GridLayoutSettings({
        controlName: "GENERAL_INCOMING_INVOICES",
        getBaseColumns: () => page.baseColumns,
        getSort: () => page.sort,
        setSort: (sort) => {
          page.sort = sort;
          page.sortTransform();
        },
        // A szűrősor mellett a fejléc-legördülők (státuszok) kiválasztása is a profil része.
        getFilter: (): SavedGridFilter => ({ grid: page.filter, dropdowns: { ...page.dropdownFilterIds } }),
        setFilter: (filter) => {
          // A még függő (debounce-olt) gépelés ne írja felül a profil szűrőjét.
          clearTimeout(page.debounceTimer);
          const saved = savedGridFilter(filter);
          page.filter = saved.grid ?? { logic: "and", filters: [] };
          page.dropdownFilterIds = {
            displayStatus: allStatusId,
            workflowStatus: allStatusId,
            accStatus: allStatusId,
            ...saved.dropdowns,
          };
          page.syncDropdownItems();
          page.filterTransform(page.filter);
        },
        onSortApplied: () => {
          // A szűrt lista rövidebb lehet, mint az aktuális oldalszám; az oldalszám-váltás magától újratölt.
          if (page.currentPageNumber !== 1) page.currentPageNumber = 1;
          else page.reload();
        },
      }),
      filterText: "",
      lastSentFilterText: "",
      invDateStart: "",
      invDateEnd: "",
      accDateStart: "",
      accDateEnd: "",
      insDateStart: "",
      insDateEnd: "",
      invStatus: "",
      invPartner: "",
      filter: {
        logic: "and",
        filters: [],
      },
      sort: [],
      debounceTimer: null,
      jsonSort: null,

      jsonFilters: {},
      defaultDisplayStatus: { ...displayStatusDefaultProps },
      defaultWorkflowStatus: { ...workflowStatusDefaultProps },
      defaultAccStatus: { ...accStatusDefaultProps },
      dropdownFilterIds: { displayStatus: allStatusId, workflowStatus: allStatusId, accStatus: allStatusId },
      incomingInvoiceFilter: "",
    };
  },

  async beforeMount() {
    // A nézet betöltése a státuszokkal párhuzamosan indul, hogy ne lassítsa az oldalt.
    const viewModeLoading = this.loadViewMode();
    const layoutLoading = this.layout.load();
    if (!configuration.operel) {
      await this.store.loadAccStatuses();
      await this.store.loadWFStatuses();
      await this.store.loadDisplayStatuses();
    }
    // Ha az alapértelmezett profil a státuszok előtt töltődött be, a legördülők csak most tudják felvenni a kiválasztást.
    this.syncDropdownItems();
    this.filterTransform(this.filter);

    this.incomingInvoiceFilter = this.$route.params["invoiceFilter"] || globalStore.incomingInvoiceFilter.General;
    this.store.incomingInvoiceFilter = this.incomingInvoiceFilter;
    await viewModeLoading;
    await layoutLoading;
    await this.store.loadInvoices(this.currentPageSize, this.currentPageNumber, this.filterText, this.jsonFilters, null, this.incomingInvoiceFilter);
    eventBus.$on("incoming-invoice-pagefilter:search", this.reload);
  },

  mounted(){
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(new Date().getFullYear() - 2);

    (this.store.filterModel.invDate as any).min = oneYearAgo; //.toISOString().split('T')[0].replaceAll('-', '.');
  },

  beforeDestroy() {
    eventBus.$off("incoming-invoice-pagefilter:search", this.reload);
  },

  computed: {
    /** A grid oszlopai a felhasználó elrendezése (sorrend, rejtett oszlopok) szerint. */
    columns(): GridColumnProps[] {
      return this.layout.columns;
    },

    baseColumns(): GridColumnProps[] {
      return [
        {
          field: "incomingInvoiceId",
          title: "GENI",
          headerClassName: "adjust_left",
          className: "adjust_left",
          cell: "geniTemplate",
        },
        {
          field: "incomingInvoiceInvoiceNo",
          title: "Számlaszám",
          cell: "incomingInvoiceInvoiceNoTemplate",
        },
        {
          field: "typeName",
          title: "Típus",
          headerClassName: "center_text",
          className: "center_text",
        },
        {
          field: "partnerName",
          title: "Partner",
          cell: "partnerTemplate",
        },
        {
          title: "Teljesítés dátuma",
          field: "incomingInvoiceShipDate",
          cell: "incomingInvoiceShipDateTemplate",
          headerClassName: "center_text",
          className: "center_text",
        },
        {
          // Fizetve: pay_date, vagy ha üres, az utolsó élő fizetési tétel dátuma (backend: effectivePayDate).
          // A rendezés szerver oldali (incomingInvoicePayDate), a fejléc-szűrőt a backend nem kezeli rá.
          title: "Fizetve",
          field: "incomingInvoicePayDate",
          cell: "effectivePayDateTemplate",
          headerClassName: "center_text",
          className: "center_text",
          filterable: false,
        },
        {
          title: "Fizetési határidő",
          field: "incomingInvoicePayTerm",
          cell: "incomingInvoicePayTermTemplate",
          headerClassName: "center_text",
          className: "center_text",
        },

        {
          field: "displayStatus",
          title: "Státusz",
          headerClassName: "center_text",
          className: "center_text",
          cell: "displayStatusTemplate",
          filterCell: "displayStatusFilterTemplate",
          sortable: false
        },

        {
          field: "workflowStatus",
          title: "Workflow státusz",
          cell: "actualStatusTemplate",
          headerClassName: "center_text",
          className: "center_text",
          width: 200,
          filterCell: "workflowStatusFilterTemplate",
          sortable: false
        },

        {
          field: "accStatus",
          title: "Könyvelési státusz",
          cell: "accStatusTemplate",
          headerClassName: "center_text",
          className: "center_text",
          filterCell: "accStatusFilterTemplate",
          filterable: configuration.operel ? false : true,
          sortable: false
        },
        {
          field: "incomingInvoiceCurrNetto",
          title: "Nettó",
          cell: "incomingInvoiceCurrNettoTemplate",
        },
        {
          field: "incomingInvoiceCurrVat",
          title: "ÁFA",
          cell: "incomingInvoiceCurrVatTemplate",
        },
        {
          field: "incomingInvoiceInvVat",
          title: "Szállítói ÁFA",
          cell: "incomingInvoiceInvVatTemplate",
        },
        {
          field: "incomingInvoiceCurrTotal",
          title: "Fizetendő",
          cell: "incomingInvoiceCurrTotalTemplate",
        },
        {
          field: "incomingInvoiceRemark",
          title: "Megjegyzés",
          cell: "incomingInvoiceRemarkTemplate",
        },
        {
          width: 50,
          cell: "commandTemplate",
          filterable: false,
          sortable: false,
        },
      ];
    },

    items() {
      this.setPageNumbers();
      return this.store.invoices;
    },

    invoiceCount() {
      return this.invoices.length;
    },

    invoices() {
      // a filtertext a globalis filter
      if (this.filterText) {
        const filtered = this.store.invoices;
        return orderBy(filterBy(filtered, this.filter), this.sort);
      } else {
        return orderBy(filterBy(this.store.invoices, this.filter), this.sort);
      }
    },

    footerText() {
      return `${Math.max((this.currentPageNumber - 1) * this.currentPageSize + 1, 0)} - ${Math.max(
        this.currentPageNumber * this.currentPageSize,
        this.invoices.length
      )} / ${this.store.totalPageCount}`;
    },

    maxPageNumber() {
      return Math.ceil(this.invoices.length / this.currentPageSize);
    },

    accountStatuses() {
      const accStatuses = [{ ...accStatusDefaultProps }];
      this.store.accountStatuses.forEach((accst) => {
        accStatuses.push(accst);
      });

      return accStatuses;
    },

    displayStatuses() {
      const displayStatuses = [{ ...displayStatusDefaultProps }];
      this.store.displayStatuses.forEach((ds) => {
        displayStatuses.push(ds);
      });

      return displayStatuses;
    },

    workflowStatuses() {
      const wfStatuses = [{ ...workflowStatusDefaultProps }];
      this.store.workflowStatuses.forEach((wfs) => {
        wfStatuses.push(wfs);
      });

      return wfStatuses;
    },

    pageTitle() {
      let title = "";
      switch (this.incomingInvoiceFilter) {
        case globalStore.incomingInvoiceFilter.ProdPurchase:
          title = "Felvásárlási jegyek";
          break;
        default:
          title = "Bejövő számlák";
          break;
      }
      return title;
    },

    newInvoiceButtonText() {
      let title = "";
      switch (this.incomingInvoiceFilter) {
        case globalStore.incomingInvoiceFilter.ProdPurchase:
          title = "Új felvásárlási jegy";
          break;
        default:
          title = "Új bejövő számla";
          break;
      }
      return title;
    },
  },

  created() {
    this.filterTextChanged = debounce.debounce(this.filterTextChanged, 500);
  },

  methods: {
    sortTransform(){
      if (this.sort.length > 0){
        this.jsonSort = {
          field: this.sort[0].field,
          order: this.sort[0].dir == "asc" ? SortOrder.Ascending : SortOrder.Descending
        }
      } else {
        this.jsonSort = null;
      }
    },

    filterChange(e: { filter: CompositeFilterDescriptor }) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(async () => {
        this.filter = e.filter;

        this.filterTransform(this.filter);
        this.reload();

        this.setCurrentPageNumber(1);
      }, 1000);
    },

    dropdownFilterChange(e: any) {
      this.dropdownFilterIds[e.target.name] = e.target.value.id;
      this.dropdownFilterTransform(e.target.name, e.target.value.id);
      this.reload();
    },

    sortChange(e: { sort: SortDescriptor[] }) {
      this.sort = e.sort;
      this.sortTransform();
      this.reload();
    },

    filterTextChanged() {
      // változatlan (trimmelt) szövegre nem indítunk kérést
      if ((this.filterText ?? "").trim() === this.lastSentFilterText) return;
      this.currentPageNumber = 1;
      this.reload(true);
    },

    createInvoice() {
      switch (this.incomingInvoiceFilter) {
        case globalStore.incomingInvoiceFilter.General:
          if (this.configuration.invoiceFlow.enabled) {
            this.$router.push(`/general-incoming-invoice/flow/create/1`);
          }
          else {
            this.$router.push(`/general-incoming-invoice/create`);
          }
          break;
        case globalStore.incomingInvoiceFilter.ProdPurchase:
          this.$router.push(`/general-incoming-invoice/flow/create/${globalStore.incomingInvoiceFilter.ProdPurchase}/1`);
      }
    },

    invoiceEditUrl(item: GeneralIngoinInvoiceDisplay) {
      return configuration.invoiceFlow.enabled
        ? `/general-incoming-invoice/flow/edit/${item.incomingInvoice.id}/2`
        : `/general-incoming-invoice/edit/${item.incomingInvoice.partner}/${item.incomingInvoice.id}`;
    },

    updateInvoice(item: GeneralIngoinInvoiceDisplay) {
      this.$router.push(this.invoiceEditUrl(item));
    },

    setPageNumbers() {
      if (this.currentPageNumber == 0) {
        return;
      }

      const maxPageNumber = Math.ceil(this.store.totalPageCount / this.currentPageSize);
      if (maxPageNumber <= 5) {
        this.firstPageNumberButtonVisible = false;
        this.secondPageNumberButtonVisible = false;
        this.thirdPageNumberButtonVisible = false;
        this.fourthPageNumberButtonVisible = false;
        this.fifthPageNumberButtonVisible = false;

        if (maxPageNumber >= 1) {
          this.firstPageNumberButtonVisible = true;
          this.firstPageNumberButtonValue = 1;
        }

        if (maxPageNumber >= 2) {
          this.secondPageNumberButtonVisible = true;
          this.secondPageNumberButtonValue = 2;
        }

        if (maxPageNumber >= 3) {
          this.thirdPageNumberButtonVisible = true;
          this.thirdPageNumberButtonValue = 3;
        }

        if (maxPageNumber >= 4) {
          this.fourthPageNumberButtonVisible = true;
          this.fourthPageNumberButtonValue = 4;
        }

        if (maxPageNumber == 5) {
          this.fifthPageNumberButtonVisible = true;
          this.fifthPageNumberButtonValue = 5;
        }
      } else {
        this.firstPageNumberButtonVisible = true;
        this.secondPageNumberButtonVisible = true;
        this.thirdPageNumberButtonVisible = true;
        this.fourthPageNumberButtonVisible = true;
        this.fifthPageNumberButtonVisible = true;

        if (maxPageNumber - this.currentPageNumber < 5) {
          this.firstPageNumberButtonValue = maxPageNumber - 4;
          this.secondPageNumberButtonValue = maxPageNumber - 3;
          this.thirdPageNumberButtonValue = maxPageNumber - 2;
          this.fourthPageNumberButtonValue = maxPageNumber - 1;
          this.fifthPageNumberButtonValue = maxPageNumber;
        } else {
          if (this.currentPageNumber < 5) {
            this.firstPageNumberButtonValue = 1;
            this.secondPageNumberButtonValue = 2;
            this.thirdPageNumberButtonValue = 3;
            this.fourthPageNumberButtonValue = 4;
            this.fifthPageNumberButtonValue = 5;
          } else {
            this.firstPageNumberButtonValue = this.currentPageNumber - 2;
            this.secondPageNumberButtonValue = this.currentPageNumber - 1;
            this.thirdPageNumberButtonValue = this.currentPageNumber;
            this.fourthPageNumberButtonValue = this.currentPageNumber + 1;
            this.fifthPageNumberButtonValue = this.currentPageNumber + 2;
          }
        }
      }
    },

    setCurrentPageNumber(pageNumber: number) {
      this.currentPageNumber = pageNumber;
    },

    decrementPageNumber() {
      if (this.currentPageNumber == 1) {
        return;
      }

      this.currentPageNumber--;
    },

    incrementPageNumber() {
      const maxPageNumber = Math.ceil(this.store.totalPageCount / this.currentPageSize);
      if (this.currentPageNumber == maxPageNumber) {
        return;
      }

      this.currentPageNumber++;
    },

    setTableView() {
      this.applyViewMode("table");

      this.filter = {
        logic: "and",
        filters: [],
      };
      this.sort = [];
      this.saveViewMode("table");
    },

    setListView() {
      this.applyViewMode("list");

      this.filter = {
        logic: "and",
        filters: [],
      };
      this.sort = [];
      this.saveViewMode("list");
    },

    applyViewMode(mode: InvoiceViewMode) {
      this.isTableView = mode === "table";
      this.isListView = mode === "list";
    },

    /** A felhasználó utoljára választott nézete (rmgenuser_setting); hiba vagy hiány esetén marad a lista. */
    async loadViewMode(): Promise<void> {
      try {
        const saved = await getUserSettingValue<string>(viewModeControlName, viewModeSettingType);
        this.savedViewMode = normalizeViewMode(saved);
      } catch (e) {
        console.log(e);
      }
      this.applyViewMode(this.savedViewMode);
    },

    async saveViewMode(mode: InvoiceViewMode): Promise<void> {
      if (mode === this.savedViewMode) return;

      try {
        const response = await setUserSetting(viewModeControlName, viewModeSettingType, mode);
        // Sikertelen mentés után a következő váltás újra megpróbálja.
        if (response === "success") this.savedViewMode = mode;
      } catch (e) {
        console.log(e);
      }
    },

    /** A grid jobb klikkje az elrendezés-menüt nyitja. */
    openLayoutMenu(event: MouseEvent) {
      (this.$refs.layoutMenu as InstanceType<typeof GridLayoutMenu>).show(event);
    },

    partnerEdit(item: GeneralIngoinInvoiceDisplay) {
      links.activate.partnerProfile(item);
    },

    reloadByAccDate() {
      if (this.store.accDateStart && this.store.accDateEnd) {
        this.store
          .loadInvoices(this.currentPageSize, this.currentPageNumber, this.filterText, this.jsonFilters, null, this.incomingInvoiceFilter)
          .then(() => (this.currentPageNumber = 1));
      }
    },

    reloadByInvDate() {
      if (this.store.invDateStart && this.store.invDateEnd) {
        this.store
          .loadInvoices(this.currentPageSize, this.currentPageNumber, this.filterText, this.jsonFilters, null, this.incomingInvoiceFilter)
          .then(() => (this.currentPageNumber = 1));
      }
    },

    // silent: keresőmezőből, teljes képernyős overlay nélkül
    reload(silent = false) {
      this.lastSentFilterText = (this.filterText ?? "").trim();
      if (silent === true) {
        this.store.searchInvoices(this.currentPageSize, this.currentPageNumber, this.lastSentFilterText, this.jsonFilters, this.jsonSort, this.incomingInvoiceFilter);
      } else {
        this.store.loadInvoices(this.currentPageSize, this.currentPageNumber, this.lastSentFilterText, this.jsonFilters, this.jsonSort, this.incomingInvoiceFilter);
      }
    },

    filterTransform(filter: any) {
      // Az összes oszlopból, a rejtettekből is, hogy a backend szűrő-JSON kulcsai ne függjenek az elrendezéstől.
      this.baseColumns.map((col) => {
        // létrehozunk egy jsont a filterhez az összes oszlopból null value-val
        if (col.field) {
          this.jsonFilters[col.field] = {
            operator: "Contains",
            value: null,
            operators: ["Contains"],
          };

          // ahol van van value (vagyis létrehozza a kendo a filter field-et) ott az írja felül a null value-t
          if (filter) {
            filter.filters.map((el: { field: string; value: string }) => {
              if (el.field === col.field) {
                this.jsonFilters[col.field] = {
                  operator: "Contains",
                  value: el.value,
                  operators: ["Contains"],
                };
              }
            });
          }
        }
      });
      // A legördülők szűrője nem a Kendo szűrő-leíróban él, ezért a fenti nullázás után újra rá kell tenni.
      this.applyDropdownFilters();
    },

    /** A fejléc-legördülők kiválasztása a kérés szűrő-JSON-jába. */
    applyDropdownFilters() {
      Object.entries(this.dropdownFilterIds).forEach(([field, id]) => this.dropdownFilterTransform(field, id));
    },

    /**
     * A legördülők megjelenített eleme a kiválasztott azonosító szerint. Ha a státuszlista már betöltött,
     * de az azonosító nincs benne (törölt státusz), a legördülő Összes-re áll.
     */
    syncDropdownItems() {
      const pick = <T extends { id: number }>(items: T[], field: string, fallback: T): T => {
        const found = items.find((item) => item.id === this.dropdownFilterIds[field]);
        if (!found && items.length > 1) this.dropdownFilterIds[field] = allStatusId;
        return found ?? fallback;
      };
      this.defaultDisplayStatus = pick(this.displayStatuses, "displayStatus", { ...displayStatusDefaultProps });
      this.defaultWorkflowStatus = pick(this.workflowStatuses, "workflowStatus", { ...workflowStatusDefaultProps });
      this.defaultAccStatus = pick(this.accountStatuses, "accStatus", { ...accStatusDefaultProps });
    },

    dropdownFilterTransform(field, value) {
      // Az összes oszlopból, a rejtettekből is (mint a filterTransform), hogy a rejtett státusz-oszlop szűrője is menjen.
      this.baseColumns.map((col) => {
        if (col.field === field) {
          if (value && value !== 1) {
            this.jsonFilters[col.field] = {
              operator: "Contains",
              value: value.toString(),
              operators: ["Contains"],
            };
          } else {
            this.jsonFilters[col.field] = {
              operator: "Contains",
              value: null,
              operators: ["Contains"],
            };
          }
        }
      });
    },

    convertToDate(dateString) {
      return dayjs(dateString).format("YYYY-MM-DD");
    },
  },

  watch: {
    sort: function(){
      this.sortTransform();
    },

    invDateStart: function() {
      this.store.invDateStart = this.invDateStart;
      this.reloadByInvDate();
    },

    invDateEnd: function() {
      this.store.invDateEnd = this.invDateEnd;
      this.reloadByInvDate();
    },

    accDateStart: function() {
      this.store.accDateStart = this.accDateStart;
      this.reloadByAccDate();
    },

    accDateEnd: function() {
      this.store.accDateEnd = this.accDateEnd;
      this.reloadByAccDate();
    },

    currentPageNumber: function() {
      this.reload();
    },

    currentPageSize: function() {
      this.currentPageNumber = 1;
      this.reload();
    },

    filterShow: function() {
      if (!this.filterShow) {
        //this.store.clearFilter();
        //this.store.clearSort();
      }
    },
  },
});
